import { getGlobalSelector } from './mmd';

const getRoot = () => getGlobalSelector().additionalSelectors.activitiesStatusSelectors;

export const hideNextActivityFooter = (state: any) => getRoot().hideNextActivityFooter(state);
export const isTestDriveServiceUnavailable = (state: any) => getRoot().isTestDriveServiceUnavailable(state);
